module.exports = require('./helpers/bundle-url').getBundleURL('jDW3t') + "logo-dark.ba5147f0.svg";